export const STORAGE_NAMESPACE = 'gqls:v1';

export const STORAGE_BACKENDS = {
    LOCAL: 'local',
    SESSION: 'session',
    COOKIE: 'cookie'
};

export const STORAGE_DOMAINS = {
    AUTH: 'auth',
    SESSION: 'session',
    USER: 'user',
    PREFS: 'prefs',
    CACHE: 'cache',
    SSO: 'sso'
};

export const COMPAT_KEYS = {
    IS_LOGGED_IN: 'isLoggedIn',
    USER_NAME: 'userName',
    USER_PREFIX: 'User_',
    SSO_IN_FLIGHT: 'SSO',
    TOGGLE_STATE: 'toggleState',
    VIDEO_TOGGLE_STATE: 'videoToggleState',
    USER_SELECTED_COLUMNS: 'userSelectedColumns',
    FAM_SELECTED_COLUMNS: 'useFamSelectedColumns'
};

export const OIDC_SESSION_PREFIX = 'oidc.user:';

export const createNamespacedKey = (domain, keyName) => `${STORAGE_NAMESPACE}:${domain}:${keyName}`;

export const STORAGE_KEYS = {
    authSession: {
        backend: STORAGE_BACKENDS.LOCAL,
        domain: STORAGE_DOMAINS.AUTH,
        key: createNamespacedKey(STORAGE_DOMAINS.AUTH, 'session')
    },
    ssoInFlight: {
        backend: STORAGE_BACKENDS.SESSION,
        domain: STORAGE_DOMAINS.SSO,
        key: createNamespacedKey(STORAGE_DOMAINS.SSO, 'in_flight')
    },
    ssoProvider: {
        backend: STORAGE_BACKENDS.SESSION,
        domain: STORAGE_DOMAINS.SSO,
        key: createNamespacedKey(STORAGE_DOMAINS.SSO, 'provider')
    },
    toggleState: {
        backend: STORAGE_BACKENDS.LOCAL,
        domain: STORAGE_DOMAINS.PREFS,
        key: createNamespacedKey(STORAGE_DOMAINS.PREFS, 'toggle_state')
    },
    videoToggleState: {
        backend: STORAGE_BACKENDS.LOCAL,
        domain: STORAGE_DOMAINS.PREFS,
        key: createNamespacedKey(STORAGE_DOMAINS.PREFS, 'video_toggle_state')
    },
    userSelectedColumns: {
        backend: STORAGE_BACKENDS.LOCAL,
        domain: STORAGE_DOMAINS.PREFS,
        key: createNamespacedKey(STORAGE_DOMAINS.PREFS, 'user_selected_columns')
    },
    famSelectedColumns: {
        backend: STORAGE_BACKENDS.LOCAL,
        domain: STORAGE_DOMAINS.PREFS,
        key: createNamespacedKey(STORAGE_DOMAINS.PREFS, 'fam_selected_columns')
    }
};
